module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Light.de87dfe9.woff2";